<template>
    <div class="content">
        <h1>WARENKORB</h1>
        <div v-if="ShoppingCart && ShoppingCart.Products && ShoppingCart.Products.length" class="shoppingcart-div">
            <div v-for="(item, index) in ShoppingCart.Products " :key="index" class="row item-container">
                <div :id="'Item_' + item.Id"
                    class="col-xs-12 col-sm-12 col-md-12 item-name">
                    {{ item.Name }} &nbsp;|&nbsp; {{ item.Price}} €&nbsp;
                    <i class="far fa-trash-alt trash-icon" @click="deleteItemConfirmDialogue(item.Id)" title="Löschen"></i>
                </div>
                <div :id="'DeleteItemConfirmDialogue_' + item.Id" class="delete-item">
                    <div class="delete-item-headline">Möchten Sie diesen Artikel löschen?</div>
                    <button
                        class="btn btn-secondary btn-cancel-delete-item"
                        @click="closeDeleteItemConfirmDialogue(item.Id)">
                        <i class="fas fa-ban"></i>Abbrechen
                    </button>
                    <button
                        class="btn btn-danger btn-delete-item"
                        @click="deleteItem(item.Id, item.ProductId)">
                        <i class="far fa-trash-alt"></i>Löschen
                    </button>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 item-hint">
                    <div v-if="item.ProductId === 'H2' || item.ProductId === 'G2'">
                        Bitte tragen Sie hier die persönlichen Daten beider Personen ein, für die Sie diesen Artikel bestellen.
                    </div>
                    <div v-else>
                        Bitte tragen Sie hier die persönlichen Daten der Person ein, für die Sie diesen Artikel bestellen.
                    </div>
                </div>
                <div v-if="item.ProductId === 'H2' || item.ProductId === 'G2'" class="form-group row">
                    <div class="form-headline col-md-12">Person 1:</div>
                    <div class="form-item col-md-6">
                        <input
                            type="text"
                            v-model="item.Data[0].FirstName"
                            :class="!item.Data[0].FirstName ? 'form-error' : null"
                            @input="updateShoppingcartStore()"
                            :placeholder="dataPlaceholder.FirstName">
                    </div>
                    <div class="form-item col-sm-6 col-md-6">
                        <input
                            type="text"
                            v-model="item.Data[0].LastName"
                            :class="!item.Data[0].LastName ? 'form-error' : null"
                            @input="updateShoppingcartStore()"
                            :placeholder="dataPlaceholder.LastName">
                    </div>
                    <div class="form-item col-sm-6 col-md-6">
                        <input
                            type="text"
                            v-model="item.Data[0].PlaceOfBirth"
                            :class="!item.Data[0].PlaceOfBirth ? 'form-error' : null"
                            @input="updateShoppingcartStore()"
                            :placeholder="dataPlaceholder.PlaceOfBirth">
                    </div>
                    <div class="form-item col-md-6">
                        <select
                            v-model="item.Data[0].DayOfBirth"
                            :class="!item.Data[0].DayOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in dayOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <select
                            v-model="item.Data[0].MonthOfBirth"
                            :class="!item.Data[0].MonthOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in monthOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <select
                            v-model="item.Data[0].YearOfBirth"
                            :class="!item.Data[0].YearOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in yearOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="form-label">&nbsp;Geburtsdatum</span>
                    </div>
                    <div class="form-item col-md-6">
                        <select
                            v-model="item.Data[0].HourOfBirth"
                            :class="!item.Data[0].HourOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in hourOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <select
                            v-model="item.Data[0].MinuteOfBirth"
                            :class="!item.Data[0].MinuteOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in minuteOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="form-label">&nbsp;Geburtszeit</span>
                    </div>
                    <div class="form-item col-md-6">
                        <select
                            v-model="item.Data[0].Gender"
                            :class="!item.Data[0].Gender ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in gender" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="form-label">&nbsp;Geschlecht</span>
                    </div>
                    <div class="form-headline col-md-12">Person 2:</div>
                    <div class="form-item col-md-6">
                        <input
                            type="text"
                            v-model="item.Data[1].FirstName"
                            :class="!item.Data[1].FirstName ? 'form-error' : null"
                            @input="updateShoppingcartStore()"
                            :placeholder="dataPlaceholder.FirstName">
                    </div>
                    <div class="form-item col-md-6">
                        <input
                            type="text"
                            v-model="item.Data[1].LastName"
                            :class="!item.Data[1].LastName ? 'form-error' : null"
                            @input="updateShoppingcartStore()"
                            :placeholder="dataPlaceholder.LastName">
                    </div>
                    <div class="form-item col-md-6">
                        <input
                            type="text"
                            v-model="item.Data[1].PlaceOfBirth"
                            :class="!item.Data[1].PlaceOfBirth ? 'form-error' : null"
                            @input="updateShoppingcartStore()"
                            :placeholder="dataPlaceholder.PlaceOfBirth">
                    </div>
                    <div class="form-item col-md-6">
                        <select
                            v-model="item.Data[1].DayOfBirth"
                            :class="!item.Data[1].DayOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in dayOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <select
                            v-model="item.Data[1].MonthOfBirth"
                            :class="!item.Data[1].MonthOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in monthOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <select
                            v-model="item.Data[1].YearOfBirth"
                            :class="!item.Data[1].YearOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in yearOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="form-label">&nbsp;Geburtsdatum</span>
                    </div>
                    <div class="form-item col-md-6">
                        <select
                            v-model="item.Data[1].HourOfBirth"
                            :class="!item.Data[1].HourOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in hourOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <select
                            v-model="item.Data[1].MinuteOfBirth"
                            :class="!item.Data[1].MinuteOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in minuteOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="form-label">&nbsp;Geburtszeit</span>
                    </div>
                    <div class="form-item col-md-6">
                        <select
                            v-model="item.Data[1].Gender"
                            :class="!item.Data[1].Gender ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in gender" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="form-label">&nbsp;Geschlecht</span>
                    </div>
                </div>
                <div v-else class="form-group row">
                    <div class="form-item col-md-6">
                        <input
                            type="text"
                            v-model="item.Data[0].FirstName"
                            :class="!item.Data[0].FirstName ? 'form-error' : null"
                            @input="updateShoppingcartStore()"
                            :placeholder="dataPlaceholder.FirstName">
                    </div>
                    <div class="form-item col-md-6">
                        <input
                            type="text"
                            v-model="item.Data[0].LastName"
                            :class="!item.Data[0].LastName ? 'form-error' : null"
                            @input="updateShoppingcartStore()"
                            :placeholder="dataPlaceholder.LastName">
                    </div>
                    <div class="form-item col-md-6">
                        <input
                            type="text"
                            v-model="item.Data[0].PlaceOfBirth"
                            :class="!item.Data[0].PlaceOfBirth ? 'form-error' : null"
                            @input="updateShoppingcartStore()"
                            :placeholder="dataPlaceholder.PlaceOfBirth">
                    </div>
                    <div class="form-item col-md-6">
                        <select
                            v-model="item.Data[0].DayOfBirth"
                            :class="!item.Data[0].DayOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in dayOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <select
                            v-model="item.Data[0].MonthOfBirth"
                            :class="!item.Data[0].MonthOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in monthOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <select
                            v-model="item.Data[0].YearOfBirth"
                            :class="!item.Data[0].YearOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in yearOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="form-label">&nbsp;Geburtsdatum</span>
                    </div>
                    <div class="form-item col-md-6">
                        <select
                            v-model="item.Data[0].HourOfBirth"
                            :class="!item.Data[0].HourOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in hourOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <select
                            v-model="item.Data[0].MinuteOfBirth"
                            :class="!item.Data[0].MinuteOfBirth ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in minuteOfBirth" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="form-label">&nbsp;Geburtszeit</span>
                    </div>
                    <div class="form-item col-md-6">
                        <select
                            v-model="item.Data[0].Gender"
                            :class="!item.Data[0].Gender ? 'form-error' : null"
                            @change="updateShoppingcartStore()">
                            <option v-for="option in gender" :value="option.value" :key="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <span class="form-label">&nbsp;Geschlecht</span>
                    </div>
                </div>
            </div>
            <div class="row row-shop-amount">
                <div class="col-xs-12 col-sm-12 col-md-12 shop-sum">
                    Gesamtbetrag &nbsp;|&nbsp; {{ amount }} €
                </div>
            </div>
            <button
                class="btn btn-success btn-to-checkout"
                :disabled="toCheckoutButtonDisabled"
                @click="toCheckout()">
                <i class="fas fa-credit-card" title="Bestellung"></i>Weiter zur Bestellung
            </button>
            <div id="NotificationSuccess" class="notification-shoppingcart notification-success"></div>
            <div id="NotificationHint" class="notification-shoppingcart notification-hint"></div>
            <div id="NotificationError" class="notification-shoppingcart notification-error"></div>
        </div>
        <div v-else>
            Es befinden sich noch keine Artikel in Ihrem Warenkorb.
        </div>
    </div>
</template>

<script>
import Products from '../productdata/products.json';
import JQuery from 'jquery';
let $ = JQuery;

export default {
    name: 'shoppingcart',
    components: {
        Products
    },
    data() {
        return {
            ShoppingCart: {},
            amount: 0,
            count: 0,
            dayOfBirth: [],
            monthOfBirth: [],
            yearOfBirth: [],
            hourOfBirth: [],
            minuteOfBirth: [],
            gender: [],
            toCheckoutButtonDisabled: false
        };
    },
    computed: {
        dataPlaceholder() {
            return {
                FirstName: 'Vorname',
                LastName: 'Nachname',
                PlaceOfBirth: 'Geburtsort',
                Gender: 'Geschlecht'
            };
        },
        inputClass() {
            return {
                FirstName: 'form-error'
            };
        }
    },
    methods: {
        /**
         * method for filling form selects
         */
        fillSelects() {
            for (let i = 0; i <= 31; i++) {
                let text = (i < 10 ? '0' : '') + i;
                this.dayOfBirth.push({
                    value: i > 0 ? ((i < 10 ? '0' : '') + i) : null,
                    text: i > 0 ? text : '--'
                });
            }

            for (let i = 0; i <= 12; i++) {
                let text = (i < 10 ? '0' : '') + i;
                this.monthOfBirth.push({
                    value: i > 0 ? ((i < 10 ? '0' : '') + i) : null,
                    text: i > 0 ? text : '--'
                });
            }

            let currentYear = new Date().getFullYear();
            for (let i = currentYear + 1; i >= (currentYear - 120); i--) {
                this.yearOfBirth.push({
                    value: i <= currentYear ? i : null,
                    text: i <= currentYear ? i : '--'
                });
            }

            for (let i = -1; i <= 23; i++) {
                let text = (i < 10 ? '0' : '') + i;
                this.hourOfBirth.push({
                    value: i >= 0 ? ((i < 10 ? '0' : '') + i) : null,
                    text: i >= 0 ? text : '--'
                });
            }

            for (let i = -1; i <= 59; i++) {
                let text = (i < 10 ? '0' : '') + i;
                this.minuteOfBirth.push({
                    value: i >= 0 ? ((i < 10 ? '0' : '') + i) : null,
                    text: i >= 0 ? text : '--'
                });
            }

            for (let i = 0; i <= 2; i++) {
                let text = '--';
                if (i === 1) {
                    text = 'weiblich';
                }
                if (i === 2) {
                    text = 'männlich';
                }
                this.gender.push({
                    value: i > 0 ? text : null,
                    text: text
                });
            }
        },

        /**
         * method for getting shopingcart content,
         * ...calculating amount
         * ...and saving amount into localStorage
         */
        getShoppingCartContent() {
            this.amount = 0;

            if (localStorage.shoppingcart && localStorage.shoppingcart !== '') {
                this.ShoppingCart = JSON.parse(localStorage.shoppingcart);

                if (this.ShoppingCart.Products) {
                    this.ShoppingCart.Products.forEach(item => {
                        this.amount += parseInt(item.Price);
                    });

                    this.ShoppingCart.Sum = this.amount;

                    this.sortShoppingcartProductsByKey(this.ShoppingCart.Products, 'SortId');
                    localStorage.shoppingcart = JSON.stringify(this.ShoppingCart);
                }
            }
        },

        /**
         * method for sorting shopingcart products alphanumerical
         * @param array
         * @param key
         * @returns {*|Array.<T>}
         */
        sortShoppingcartProductsByKey(array, key) {
            return array.sort(function(a, b) {
                let x = a[key];
                let y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },

        /**
         * method for deleting an item from shoppingcart,
         * ...update navigation items
         * ...and save the reduced shoppingcart into localStorage
         * @param id
         * @param productId
         */
        deleteItem(id, productId) {
            for (let i = 0; i < this.ShoppingCart.Products.length; i++) {
                if (id === this.ShoppingCart.Products[i].Id) {
                    this.emitLogData('shoppingcart', 'deleteItem_' + productId);
                    this.ShoppingCart.Products.splice(i, 1);
                    break;
                }
            }

            $('.delete-item').hide();

            if (this.ShoppingCart.Products.length <= 0) {
                this.ShoppingCart.ProductsValid = false;
            }

            this.updateShoppingcartStore();
            this.getShoppingCartContent();
        },

        deleteItemConfirmDialogue(id) {
            const dialogue = $('#DeleteItemConfirmDialogue_' + id);
            if (!dialogue.is(':visible')) {
                dialogue.slideDown('fast');
            }
        },

        closeDeleteItemConfirmDialogue(id) {
            const dialogue = $('#DeleteItemConfirmDialogue_' + id);
            dialogue.slideUp('fast');
        },

        /**
         * method for routing to checkout page, if form is valid.
         * ...otherwise it displays an error notification
         */
        toCheckout() {
            if (this.formValidation() === true) {
                this.emitLogData('shoppingcart', 'toCheckoutButton');
                this.$router.push({ path: 'checkout' });
            } else {
                this.toCheckoutButtonDisabled = true;
                let notification = $('#NotificationError');
                notification.html('Bitte überprüfen Sie Ihre Formulareingaben.');
                notification.fadeIn('slow');
                let that = this;
                setTimeout(function() {
                    that.toCheckoutButtonDisabled = false;
                    notification.fadeOut();
                }, 3400);
            }
        },

        /**
         * method for validating shoppingcart form
         * @returns {boolean}
         */
        formValidation() {
            let formValid = true;
            this.ShoppingCart.Products.forEach(item => {
                let loopLimit = 1;
                if (item.ProductId === 'H2') {
                    loopLimit = 2;
                }
                for (let i = 0; i < loopLimit; i++) {
                    if (!item.Data[i].FirstName) { formValid = false; break; }
                    if (!item.Data[i].LastName) { formValid = false; break; }
                    if (!item.Data[i].PlaceOfBirth) { formValid = false; break; }
                    if (!item.Data[i].DayOfBirth) { formValid = false; break; }
                    if (!item.Data[i].MonthOfBirth) { formValid = false; break; }
                    if (!item.Data[i].YearOfBirth) { formValid = false; break; }
                    if (!item.Data[i].HourOfBirth) { formValid = false; break; }
                    if (!item.Data[i].MinuteOfBirth) { formValid = false; break; }
                    if (!item.Data[i].Gender) { formValid = false; break; }
                }
            });

            return formValid;
        },

        /**
         * method for updating locatStorage
         * ...and updating navigation checkout item
         */
        updateShoppingcartStore() {
            this.ShoppingCart.ProductsValid = this.formValidation();

            localStorage.shoppingcart = JSON.stringify(this.ShoppingCart);

            this.$emit('update-shoppingcart');
        },

        scrolltoProductId(id) {
            let item = $('#Item_' + id);

            $([document.documentElement, document.body]).animate({
                scrollTop: item.offset().top - 10
            }, 500);
        },

        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    created() {
        this.products = Products;
        this.fillSelects();
        this.getShoppingCartContent();
    },
    mounted() {
        this.emitLogData('shoppingcart', 'visit');
        if (typeof this.$route.params.productId !== 'undefined') {
            this.scrolltoProductId(this.$route.params.productId);
        }
    },
    beforeDestroy() {
        this.emitLogData('shoppingcart', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .shoppingcart-div {
        position: relative;
    }
    .item-container {
        padding-top: 15px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
    .item-name {
        position: relative;
        font-weight: bold;
        padding-left: 0 !important;
    }
    .item-hint {
        color: gray;
        line-height: 1.1em;
        padding-left: 0 !important;
        margin: 5px 0;
    }
    .trash-icon {
        color: gray;
        margin-left: 10px;
        cursor: pointer;
    }
    .fas {
        margin-top: -3px;
    }
    .row-shop-amount {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        padding-top: 10px;
    }
    .shop-sum {
        font-weight: bold;
        padding-left: 0 !important;
    }
    .shop-amount {
        float: right;
        font-weight: bold;
        text-align: right;
        padding-right: 0 !important;
    }
    .form-group {
        width: 100%;
        margin-bottom: 20px !important;
    }
    .form-item {
        padding: 0 5px 0 0;
    }
    .form-item input,
    .form-item select {
        border: 1px solid lightgray;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        margin-bottom: 5px;
        padding: 0 5px;
    }
    .form-item select {
        margin-right: 4px;
    }
    .form-label {
        color: gray;
    }
    input {
        width: 100%;
    }
    ::placeholder {
        color: lightgray;
    }
    .btn-to-checkout {
        margin: 40px 0;
    }
    .form-headline {
        padding: 0 !important;
    }
    .fas {
        margin-right: 10px;
    }
    .fa-trash-alt {
        margin: 0 10px 0 2px;
    }
    .fa-ban {
        margin: 0 4px 0 -5px;
    }
    @media only screen and (max-width: 600px) {
        input,
        select {
            height: 36px;
        }
    }
    .delete-item {
        padding: 10px 0;
        display: none;
    }
    .delete-item-headline {
        margin-bottom: 5px;
    }
    .btn-delete-item {
        padding-left: 5px;
    }
    .btn-cancel-delete-item {
        margin-right: 10px;
    }
</style>
